export const compileShader = (
  gl: WebGL2RenderingContext,
  type: number,
  source: string,
): WebGLShader => {
  const shader = gl.createShader(type);
  if (shader === null) throw new Error('gl.createShader returned null');
  gl.shaderSource(shader, source);
  gl.compileShader(shader);
  if (gl.getShaderParameter(shader, gl.COMPILE_STATUS) !== true) {
    const log = gl.getShaderInfoLog(shader) ?? '<no info log>';
    gl.deleteShader(shader);
    throw new Error(`shader compile failed:\n${formatShaderLog(source, log)}`);
  }
  return shader;
};

const formatShaderLog = (source: string, log: string): string => {
  const lines = source.split('\n');
  const numbered = lines.map((l, i) => `${(i + 1).toString().padStart(4)} | ${l}`).join('\n');
  return `${log}\n--- source ---\n${numbered}`;
};
